import { Directive, HostListener, Injector, OnInit } from '@angular/core';
import { AbstractControl, NgControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { trimControlValue } from './special-characters-restirct.directive';

const OPTIONAL_NAME_PATTERN = /^(?![<\s.>])(?!.*[<\s.>]$)[a-zA-ZÀ-ÿčàâæéêèëïîôœûùç0-9\s]+(?:[-_:%/\\()`\u2122.+][a-zA-ZÀ-ÿčàâæéêèëïîôœûùç0-9)\s]+)*$/;

@Directive({
    selector: '[specialCharactersRestrictAllowEmpty]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: SpecialCharactersRestrictDirectiveAllowEmpty,
            multi: true,
        },
    ],
    standalone: false
})
export class SpecialCharactersRestrictDirectiveAllowEmpty implements Validator, OnInit {
  private ngControl: NgControl | null = null;

  constructor(private injector: Injector) {}

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl, null);
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value == null || String(value).trim() === '') {
      return null;
    }
    return OPTIONAL_NAME_PATTERN.test(String(value).trim()) ? null : { invalid: true };
  }

  @HostListener('blur')
  trimOnBlur(): void {
    trimControlValue(this.ngControl?.control);
  }
}
